<div class="py-32">
  <hr class="block border-t-2 border-gray-light h-0 bg-none" />
</div>
